import validate from "/home/runner/work/solo-brands-scaffolding/solo-brands-scaffolding/webapp/node_modules/nuxt/dist/pages/runtime/validate.js";
import _0_45i18n_45global from "/home/runner/work/solo-brands-scaffolding/solo-brands-scaffolding/webapp/middleware/0.i18n.global.ts";
import dy_45global from "/home/runner/work/solo-brands-scaffolding/solo-brands-scaffolding/webapp/middleware/dy.global.ts";
import manifest_45route_45rule from "/home/runner/work/solo-brands-scaffolding/solo-brands-scaffolding/webapp/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _0_45i18n_45global,
  dy_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "bc-cart-validate": () => import("/home/runner/work/solo-brands-scaffolding/solo-brands-scaffolding/webapp/middleware/bc-cart-validate.ts"),
  connection: () => import("/home/runner/work/solo-brands-scaffolding/solo-brands-scaffolding/webapp/middleware/connection.ts")
}